'use strict';

var novicell = novicell || {};

novicell.imageMap = novicell.imageMap || new function () {
    const imageMaps = document.querySelectorAll('.js-image-map');

    this.init = function () {
        if (!imageMaps) {
            return;
        }
        for (let i = 0; i < imageMaps.length; i++) {
            const imageMapElm = imageMaps[i];
            const imageMapPoints = imageMapElm.querySelectorAll('.js-image-map-point');
            const imageMapRightBorder = imageMapElm.getBoundingClientRect().left + outerWidth(imageMapElm);

            for (let p = 0; p < imageMapPoints.length; p++) {
                const pointElm = imageMapPoints[p];

                const pointElmWidth = outerWidth(pointElm);
                const pointRightBorder = pointElm.getBoundingClientRect().left + pointElmWidth;
                const pointIconWidth = outerWidth(pointElm);

                if (pointRightBorder > imageMapRightBorder) {
                    pointElm.classList.add('image-map-point--turn-left');
                }
            }
        }
    };

    function outerWidth(el) {
        var width = el.offsetWidth;
        var style = getComputedStyle(el);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
    }
}();
